
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Rocket from 'plaid-threads/Icons/Rocket';
import Libraries from 'plaid-threads/Icons/Libraries';
import Guide from 'plaid-threads/Icons/Guide';
import Overview from '../../../../components/docs/Overview';
import Actions from '../../../../components/docs/Actions';
export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn about making one-time payments (Single Immediate Payments) in Europe.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Header title='Payment Initiation' subtitle='Use Payment Initiation for one-time payments' mdxType="Header" />
    <Actions.SmallWrapper miniTitle='Get started with Payment Initiation'>
  <Actions.SmallCard icon={<Libraries mdxType="Libraries" />} title='API Reference' link='/docs/api/products/payment-initiation/' />
  <Actions.SmallCard icon={<Rocket mdxType="Rocket" />} title='Integration Guide' link='/docs/payment-initiation/payment-initiation-one-time/add-to-app' />
  <Actions.SmallCard icon={<Guide mdxType="Guide" />} title='Onboarding and account funding guide' link='/docs/payment-initiation/payment-initiation-one-time/user-onboarding-and-account-funding' />
    </Actions.SmallWrapper>
    <h4 {...{
      "id": "payment-initiation"
    }}>{`Payment Initiation`}</h4>
    <p>{`Plaid's one-time Payment Initiation functionality enables your users to make secure, real-time payments without manually entering their account details or leaving your app. Perfect for account funding, marketplace transactions, or any single payment needs, one-time payments, also known in the UK as Single Immediate Payments, provide a faster, easier, and safer way to move money.`}</p>
    <p>{`Benefits of Payment Initiation:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Faster, easier, safer:`}</strong>{` Real-time payments that boost revenue while reducing fraud and chargebacks with identity and bank account verification.`}</li>
      <li parentName="ul"><strong parentName="li">{`Infrastructure built for scale:`}</strong>{` Plaid handles the backend heavy lifting with instant notifications, seamless reconciliation, and real-time settlement across 18 European markets.`}</li>
      <li parentName="ul"><strong parentName="li">{`Multi-rail support:`}</strong>{` Underpinned by Faster Payments Service (FPS), SEPA Instant Credit Transfer, SEPA Credit Transfer and local country payment rails. Easily decide the payment rails with a single setting, using the same integration code.`}</li>
    </ul>
    <p>{`By combining one-time payments with the optional `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/"
      }}>{`Virtual Accounts`}</a>{` product, you can enable even more functionality, such as sending refunds to users, allowing your users to pay out a credit balance to a bank account, or gaining granular visibility into the settlement status of a payment.`}</p>
    <h4 {...{
      "id": "integration-details"
    }}>{`Integration details`}</h4>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/payment-initiation-one-time/add-to-app"
      }}>{`Add Payment Initiation to your App`}</a>{` guide to learn more about the product and how to implement it using Plaid Link.`}</p>
    <p>{`For a complete integration, you will need to `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/payment-status"
      }}>{`track payment status`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/payment-initiation-one-time/handling-failed-payments"
      }}>{`handle failed payments`}</a>{`. `}</p>
    <p>{`If you plan to implement refund capabilities, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/payment-initiation-one-time/refunds"
      }}>{`refunds`}</a>{`.`}</p>
    <h4 {...{
      "id": "sample-app"
    }}>{`Sample app`}</h4>
    <p>{`For a simple real-world implementation of Payment Initiation, see the `}<a parentName="p" {...{
        "href": "https://github.com/plaid/payment-initiation-pattern-app"
      }}>{`Payment Initiation Pattern App`}</a>{` on GitHub, which uses Payment Initiation in an account funding use case.`}</p>
    <h4 {...{
      "id": "onboarding-and-account-funding-integration-guide"
    }}>{`Onboarding and account funding integration guide`}</h4>
    <p>{`See `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/payment-initiation-one-time/user-onboarding-and-account-funding"
      }}>{`User onboarding and account funding`}</a>{` for an implementation guide to using Payment Initiation as part of a KYC and AML compliant onboarding flow.`}</p>
    <h4 {...{
      "id": "testing-payment-initiation"
    }}>{`Testing Payment Initiation`}</h4>
    <p>{`Payments can immediately be tried out with test data in the Sandbox environment. In order to test payments against live Items in Production, you will need to first request access by `}<a parentName="p" {...{
        "href": "https://plaid.com/contact"
      }}>{`contacting sales`}</a>{` or your account manager.`}</p>
    <p>{`For details on any payment limits in Production, contact your Plaid account manager.`}</p>
    <h4 {...{
      "id": "pricing"
    }}>{`Pricing`}</h4>
    <p>{`Payment Initiation is billed on a `}<a parentName="p" {...{
        "href": "/docs/account/billing/#payment-initiation-fee-model"
      }}>{`per-payment model`}</a>{`. To view the exact pricing you may be eligible for, `}<a parentName="p" {...{
        "href": "https://plaid.com/contact/"
      }}>{`contact sales`}</a>{`. `}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "payment-initiation",
        level: 4,
        title: "Payment Initiation",
      },
{
        id: "integration-details",
        level: 4,
        title: "Integration details",
      },
{
        id: "sample-app",
        level: 4,
        title: "Sample app",
      },
{
        id: "onboarding-and-account-funding-integration-guide",
        level: 4,
        title: "Onboarding and account funding integration guide",
      },
{
        id: "testing-payment-initiation",
        level: 4,
        title: "Testing Payment Initiation",
      },
{
        id: "pricing",
        level: 4,
        title: "Pricing",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
